
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/sobre",
      function () {
        return require("private-next-pages/pt-br/sobre/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/sobre"])
      });
    }
  